<template>
  <div style="position: relative">
    <baidu-map
      class="map"
      :center="center"
      :zoom="15"
      :scroll-wheel-zoom="true"
      ak="ApDQTUF556xyzFgFZAoa2WVJVdbJtPOH"
      @ready="handleMapReady"
    >
    </baidu-map>
  </div>
</template>
<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import { positionApi } from "@/services/all-api.js";
export default {
  data() {
    return {
      map: "",
      BMap: "",
      markerList: [],
      markerData: [],
      isLoading: true,
      loopTimer: null,
      center: {
        lng: 103.718953,
        lat: 36.104493
      }
    }
  },
  components: {
    BaiduMap
  },
  props: {
    olderGid: {
      type: String,
      default: null,
    },
    date: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleMapReady({ BMap, map }) {
      this.map = map;
      this.BMap = BMap;
      this.loadData({
        index: 0,
        size: 20,
        userId: this.olderGid,
        start: this.Utils.dateFormat(this.date, 'YYYY-MM-DD 00:00:00'),
        end: this.Utils.dateFormat(this.date + 86400000, 'YYYY-MM-DD 00:00:00')
      });
    },
    async renderIcons(reqObj) {
      var vm = this;
      this.isLoading = true;
      try {
        await positionApi.getOneOlderRecordApi({ ...reqObj }).then(
          result => {
            if (result.code === 0) {
              let res = result.data;
              vm.markerList.forEach((marker) => {
                vm.map.removeOverlay(marker);
              });
              vm.markerList = [];

              function markerClick(e) {
                vm.infoWindow.setContent(e.target.content);
                vm.map.openInfoWindow(vm.infoWindow, e.target.getPosition());
              }

              vm.infoWindow = new vm.BMap.InfoWindow("", {
                width: 320,
                height: 160,
                offset: new vm.BMap.Size(0, -20)
              });

              for (let item of res.Data) {
                this.markerData = res.Data.map(item => ({
                  ...item,
                  lat: item.GLat || 36.104493,
                  lon: item.GLon || 103.718953
                }));

                let point = new vm.BMap.Point(
                  item.GLon || 103.718953,
                  item.GLat || 36.104493
                );

                let icon = new vm.BMap.Icon(
                  require("@/assets/images/mass_red.png"),
                  new vm.BMap.Size(24, 24),
                  {
                    anchor: new vm.BMap.Size(12, 12)
                  }
                );

                let marker = new vm.BMap.Marker(point, { icon: icon });

                marker.content =
                  `<div class="infoContainer">
                  <div class="oneRow"><span class="text name">老人姓名:${item.UserName || '-'}</span></div>
                  <div class="oneRow"><span class="text">定位地址:${item.Address || '-'}</span></div>
                  <div class="oneRow"><span class="text">定位时间:${item.CreateTime || '-'}</span></div>
                </div>`;

                marker.addEventListener('click', markerClick);
                vm.markerList.push(marker);
                vm.map.addOverlay(marker);
              }

              if (res.Data.length && res.Data.length > 0) {
                let posObj = vm.getAveragePosition(res.Data);
                let point = new vm.BMap.Point(parseFloat(posObj.lon), parseFloat(posObj.lat));
                vm.map.setCenter(point);
              }
            }
          }
        )
      } catch (err) {
        console.log(err)
      } finally {
        this.isLoading = false
      }
    },
    loadData(reqObj) {
      this.renderIcons(reqObj)
      if (this.loopTimer) {
        clearInterval(this.loopTimer)
      }

      this.loopTimer = setInterval(() => {
        this.renderIcons(reqObj)
      }, 60000)
    },
    getAveragePosition(arr) {
      let longSum = 0;
      let latSum = 0;
      let length = arr.length;
      for (let item of arr) {
        longSum += item.GLon;
        latSum += item.GLat
      }
      return { lon: (longSum / length).toFixed(6), lat: (latSum / length).toFixed(6) }
    }
  },
  beforeDestroy() {
    clearInterval(this.loopTimer)
  }
}
</script>
<style>
.map {
  width: 100%;
  height: 200px;
}
.infoContainer {
  padding: 10px;
  line-height: 1.8;
}
.oneRow {
  margin-bottom: 5px;
}
.text {
  font-size: 14px;
  color: #333;
}
.text.name {
  font-weight: bold;
  color: #0063ff;
}
</style>